export default __webpack_public_path__ + "static/media/edit-2.4b07b2bf.svg";